import React, { useEffect , useState } from "react";
import { t } from "i18next";
import { useHistory } from "react-router-dom";

import WithMap from "components/Hoc/WithMap";
// import PageHeader from "components/PageHeader";
import TextInput from "components/TextInput";
import AddressHome from "icons/AddressHome";
import AddressOffice from "icons/AddressOffice";
import FixedFooter from "components/FixedFooter";

import useFormAddDeliveryAddress from "./useFormAddDeliveryAddress";
import CustomModal from "components/CustomModal";
import ChangeActionPopup from "../Modals/ChangeActionPopup";
import { PageHeaderV2 } from "components/PageHeader";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";
import { CustomButton } from "components/Button";
import { TranslationText } from "components/TextTranslationContainer";
import * as UTILS from "utils/Utils";
// todo: requires cleanup
function AddDeliveryAddress(props) {
  const {
    errors,
    children,
    showAreaPoup,
    onSubmit,
    isEnabled,
    gotoCheckoutPage,
    handleRefineLocation,
    goBacktomapscreen,
    isSaveAddress,
    temporarymapAddress,
    temporaryuserLocation,
    temporaryzoom,
  } = props;
  const [mapref, setMapRef] = useState(null);
  const history = useHistory();
  const { goToLogin, goToSettings } = useDelivertPickupFn();
  const { formState, handleFormChange, handleFormSubmit } =
    useFormAddDeliveryAddress({
      gotoCheckoutPage,
      onSubmit,
    });

  const addnewaddress = (e) => {
    const geoLocationObj = {
      temporarymapAddress,
      temporaryuserLocation,
      temporaryzoom,
    };
    if(!temporarymapAddress?.streetAddress && !temporarymapAddress?.city && !temporarymapAddress?.country && !temporarymapAddress?.area) {
      UTILS.errorNotification("Please select a valid location");
      handleRefineLocation();
      return
    }
    handleFormSubmit(e, geoLocationObj);
  };

  const [isOpenChangeStreetAddressModal, setIsOpenChangeStreetAddressModal] =
    useState(false);

  const AddressTypeObj = [
    {
      value: "Home",
      label: t("Home"),
      // icon: <AddressHome />,
    },
    {
      value: "Office",
      label: t("Office"),
      // icon: <AddressOffice />,
    },
    {
      value: "Other",
      label: t("Other"),
      // icon: <></>,
    },
  ];


  return (
    <div className="create-address fixced  bg-white">
      <PageHeaderV2
        pageTitle={"Add Delivery Address"}
        authClick={goToLogin}
        userClick={goToSettings}
        containerStyleProps={{
          style: {
            position: "sticky",
            zIndex: 10,
          },
        }}
      />
      <div className="w-full bg-gray-100 h-56">
        <WithMap
          class="map-height"
          width="100%"
          showInput={false}
          mapref={mapref}
          setMapRef={setMapRef}
          zoomChanging={false}
          height="224px"
          googlemapState={{
            userLocation: {
              lat: temporaryuserLocation?.coordinates?.lat,
              lng: temporaryuserLocation?.coordinates?.lng,
            },
            zoom: temporaryzoom,
            mapAddress: temporarymapAddress,
          }}
          zoomerror={null}
          isZoomModalOpen={false}
          setZoomErrorModal={() => {}}
        />
      </div>
      <div className="flex justify-center pt-4">
        <CustomButton
          onClick={handleRefineLocation}
          outline={true}
          className="w-fit"
          style={{
            padding: "5px 10px",
          }}
        >
          <TranslationText text="Change Location" />
        </CustomButton>
      </div>
      <div className="felx jsutify-center mx-4 pt-7">
        <TextInput
          label={t("Full Address")}
          value={formState.values?.address}
          onChange={(e) => handleFormChange(e)}
          name="address"
          mandatory={true}
          labelClasses="text-14x text-black mb-2"
          inputClasses="focus:outline-none mb-4 mt-2 flex-1 text-16x block w-full rounded-8x border shadow-input px-2 py-3 border-gray-200"
          placeHolder={t("Enter your complete address")}
          error={formState.errors?.address}
        />
        {/* <div onClick={() => setIsOpenChangeStreetAddressModal(true)}>
          <TextInput
            label={t("Map Address")}
            value={temporarymapAddress?.streetAddress}
            onChange={() => {}}
            name="mapAddress"
            mandatory={true}
            labelClasses="text-14x text-black"
            inputClasses="focus:outline-none mb-4 flex-1 text-16x block w-full rounded border shadow-input px-2 py-3 border-gray-200 cursor-pointer"
            placeHolder={t("Google Map Address")}
            readOnly={true}
            error={errors?.streetAddress}
          />
        </div> */}

        {children &&
          children?.map((child, index) => {
            return <div key={index}>{child}</div>;
          })}
        <TextInput
          label={t("Apartment No.")}
          value={formState.values?.appartmentNo}
          onChange={(e) => handleFormChange(e)}
          name="appartmentNo"
          mandatory={false}
          labelClasses="text-14x text-black"
          inputClasses="focus:outline-none mb-4 mt-2 flex-1 rounded-8x text-16x block w-full rounded border shadow-input px-2 py-3 border-gray-200"
          placeHolder={t("Enter your apartment no.")}
          error={formState.errors?.appartmentNo}
        />
        <TextInput
          label={t("Building Name")}
          value={formState.values?.building}
          onChange={(e) => handleFormChange(e)}
          name="building"
          mandatory={false}
          labelClasses="text-14x text-black"
          inputClasses="focus:outline-none mb-4 mt-2 flex-1 rounded-8x text-16x block w-full rounded border shadow-input px-2 py-3 border-gray-200"
          placeHolder={t("Enter your building name")}
          error={formState.errors?.building}
        />
        <TextInput
          label={t("Floor number")}
          value={formState.values?.floor}
          onChange={(e) => handleFormChange(e)}
          name="floor"
          mandatory={false}
          labelClasses="text-14x text-black"
          inputClasses="focus:outline-none mb-4 mt-2 flex-1 rounded-8x text-16x block w-full rounded border shadow-input px-2 py-3 border-gray-200"
          placeHolder={t("Enter your floor number")}
          error={formState.errors?.floor}
        />
        <CustomModal
          open={isOpenChangeStreetAddressModal}
          setOpen={setIsOpenChangeStreetAddressModal}
          bodyclasses="flex"
          overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
        >
          <ChangeActionPopup
            title={t(
              "Your selected delivery location is x do you wish to change it",
              {
                streetAddress: temporarymapAddress?.streetAddress,
              }
            )}
            handleClickYes={handleRefineLocation}
            handleClickNo={() => {
              setIsOpenChangeStreetAddressModal(false);
            }}
          />
        </CustomModal>
        <CustomModal
          open={isSaveAddress}
          setOpen={goBacktomapscreen}
          bodyclasses="flex"
          overlayClasses="fixed h-screen w-screen top-0 bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-40"
        >
          <ChangeActionPopup
            title={t("Would you like to save the address")}
            handleClickYes={(e) => {
              goBacktomapscreen(false);
              addnewaddress(e);
            }}
            handleClickNo={() => {
              goBacktomapscreen(false);
              history.goBack();
            }}
          />
        </CustomModal>
        <div className="py-2 cursor-pointer">
          <label className="text-14x text-black">
            {t("Address label")} <span className="text-red-500">*</span>
          </label>
          <div className="text-red-500">{formState.errors?.addressType}</div>

          <div className="flex gap-2 switch-field mt-2">
            {AddressTypeObj.map((type, index) => {
              const isSelected = formState?.values?.addressType === type.value;
              return (
                <CustomButton
                  key={index}
                  outline={!isSelected}
                  onClick={() =>
                    handleFormChange({
                      target: { name: "addressType", value: type.value },
                    })
                  }
                  style={{
                    padding: "5px 10px",
                  }}
                >
                  {/* <div className="flex items-center gap-2"> */}
                  {/* <span className="text-16x">{type.icon}</span> */}
                  <TranslationText text={type.label} />
                  {/* </div> */}
                </CustomButton>
              );
            })}
          </div>
        </div>
        <div id="addressLabel"></div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      {!showAreaPoup && (
        <FixedFooter
          page={false}
          from="add address"
          containerStyleProps={{
            className: "dummy-class",
            style: {},
          }}
          innerStyleProps={{
            className: "bg-dark-blue-100 p-5",
            style: {},
          }}
        >
          <CustomButton onClick={addnewaddress} disabled={!isEnabled}>
            <TranslationText text="Save Address" />
          </CustomButton>
        </FixedFooter>
      )}
    </div>
  );
}

export default AddDeliveryAddress;
